import _isEmpty from 'lodash/isEmpty'
import _isPlainObject from 'lodash/isPlainObject'
import type {
  ScoringDefinedCreditProgram,
  ScoringDefinedCreditProgramV1,
  ScoringDefinedCreditProgramV2
} from 'share/types/api/credits'

export const isScoringOptionsObject = (
  program: ScoringDefinedCreditProgram | undefined
): program is ScoringDefinedCreditProgramV1 => {
  if (!program) return false
  return _isPlainObject(program.options) && !_isEmpty(program.options)
}

export const isScoringOptionsArray = (
  program: ScoringDefinedCreditProgram | undefined
): program is ScoringDefinedCreditProgramV2 => {
  if (!program) return false
  return Array.isArray(program.options) && program.options.length > 0
}
